import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RedirectIfLoggedInGuard } from '@app/shared/guards/redirect-if-logged-in.guard';
import { LogoutComponent } from './components/logout/logout.component';
import { ConfirmEmailComponent } from './pages/confirm-email/confirm-email.component';
import { CsLoginComponent } from './pages/cs-login/cs-login.component';
import { HostInviteSuccessDoneComponent } from './pages/host-invite-success-done/host-invite-success-done.component';
import { HostInviteSuccessComponent } from './pages/host-invite-success/host-invite-success.component';
import { HostInviteComponent } from './pages/host-invite/host-invite.component';
import { InviteComponent } from './pages/invite/invite.component';
import { LoginComponent } from './pages/login/login.component';
import { MagicLinkLoginComponent } from './pages/magic-link-login/magic-link-login.component';
import { PasswordSetComponent } from './pages/password-set/password-set.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'hello',
    pathMatch: 'full',
  },
  {
    path: 'hello',
    component: LoginComponent,
    canActivate: [RedirectIfLoggedInGuard],
    data: {
      title: 'Hello!',
      shouldReuse: false,
    },
  },
  {
    path: 'hello/:email',
    component: LoginComponent,
    data: {
      title: 'Hello!',
      shouldReuse: false,
    },
  },
  {
    path: 'cs/:token',
    component: CsLoginComponent,
    data: {
      shouldReuse: false,
    },
  },
  {
    path: 'email-login/:token',
    component: MagicLinkLoginComponent,
    data: {
      title: 'Login via email',
      shouldReuse: false,
    },
  },
  {
    path: 'email-confirm/:token',
    component: ConfirmEmailComponent,
    data: {
      shouldReuse: false,
    },
  },
  {
    path: 'email-confirm',
    component: ConfirmEmailComponent,
  },
  {
    path: 'password/:identifier',
    component: PasswordSetComponent,
    data: {
      shouldReuse: false,
    },
  },
  {
    path: 'invite/:token',
    component: InviteComponent,
    data: {
      title: 'Accept your invite',
      shouldReuse: false,
    },
  },
  {
    path: 'hosts/accept/:token',
    component: HostInviteComponent,
    data: {
      title: 'Accept your invite',
      shouldReuse: false,
    },
  },
  {
    path: 'hosts/success/airbnb-official/:channel_id/:invitation_uuid',
    component: HostInviteSuccessComponent,
    data: {
      title: 'Connected your account',
      shouldReuse: false,
    },
  },
  {
    path: 'hosts/success/done',
    component: HostInviteSuccessDoneComponent,
    data: {
      title: 'Thanks!',
    },
  },
  {
    path: 'register',
    loadChildren: () => import('./signup/signup.module').then((m) => m.SignupModule),
    data: { preload: true },
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserRoutingModule {}
